var map = {
	"./authorize.svg": 1139,
	"./canceled.svg": 1140,
	"./capture.svg": 1141,
	"./card-authentication-line.svg": 1142,
	"./collect-card.svg": 1143,
	"./created.svg": 1144,
	"./failed.svg": 1145,
	"./processing.svg": 1146,
	"./requires-action-line.svg": 1147,
	"./requires-confirmation.svg": 1148,
	"./requires-payment-method.svg": 1149,
	"./succeeded.svg": 1150,
	"./verified.svg": 1151
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1138;